const TRACKING_SOURCES = [
    'dashboard_widget',
    'nav_icon',
    'truelayer_return',
    'funding_requirements',
    'bank_verification',
    'unknown'
] as const;

export type TrackingSource = (typeof TRACKING_SOURCES)[number];

export const isTrackingSource = (value: unknown): value is TrackingSource =>
    TRACKING_SOURCES.includes(value as TrackingSource);
